import { render } from "./TicketDetail.vue?vue&type=template&id=40fcdd13"
import script from "./TicketDetail.vue?vue&type=script&lang=js"
export * from "./TicketDetail.vue?vue&type=script&lang=js"

import "./TicketDetail.vue?vue&type=style&index=0&id=40fcdd13&lang=scss"

import exportComponent from "/codebuild/output/src739691156/src/fellow/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__